import styled from 'styled-components';
import ReactInputMask from 'react-input-mask';

import { control } from '../../styles/mixins';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => `${width}%`};

  :focus-within {
    label {
      color: var(--accent);
    }
  }
`;

const Label = styled.label`
  background-color: var(--surface);
  transform: translateY(10px);
  align-self: flex-start;
  padding: 0 10px 0 8px;
  margin-left: 10px;
  color: var(--ink-soft);
  font-size: 1.3rem;
  font-weight: 600;
  z-index: 1;
`;

const CustomInputMask = styled(ReactInputMask)`
  ${control}
  width: ${({ width }) => `${width}%`};
`;

export { InputContainer, Label, CustomInputMask };
